import { CATEGORY_LIST } from "../../services/CategoryModel";
import styles from "./CategoryFilter.module.css";

/* Category filter horizontal pills */
export function CategoryFilter({ selectedCategory, onSelectCategory }) {
  return (
    <div className={styles.scrollRow}>
      <button
        onClick={() => onSelectCategory("For You")}
        className={
          selectedCategory === "For You"
            ? styles.pillActive
            : styles.pillInactive
        }
      >
        For You
      </button>

      {CATEGORY_LIST.map((cat) => {
        const isSelected = selectedCategory === cat.id;
        return (
          <button
            key={cat.id}
            onClick={() => onSelectCategory(cat.id)}
            className={isSelected ? styles.pillActive : styles.pillInactive}
          >
            <span>{cat.icon}</span>
            <span>{cat.label}</span>
          </button>
        );
      })}
    </div>
  );
}
